/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Link, breakpoints, typography2 } from '@coursera/cds-core';
import type { Carousel } from '@coursera/event-pulse-types';
import { useTracker } from '@coursera/event-pulse/react';

import { usePageConfigComponentMetadata } from 'bundles/page-config-common/contexts/PageConfigComponentMetadataContext';

import _t from 'i18n!nls/consumer-home';

type Props = {
  role: {
    url: string;
    slug: string;
  };
  carouselTrackingData?: Carousel;
};

const styles = {
  link: css`
    ${breakpoints.down('sm')} {
      padding-left: var(--cds-spacing-200);
    }
  `,
};

const RecommendedRoleSecondaryCta = ({ role, carouselTrackingData }: Props) => {
  const trackV3 = useTracker();
  const pageConfigComponentMetadata = usePageConfigComponentMetadata();
  const pageConfigComponentTrackingData = {
    id: pageConfigComponentMetadata?.id,
    index: pageConfigComponentMetadata?.index ?? -1,
    name: pageConfigComponentMetadata?.name ?? 'unknown',
    recommender: pageConfigComponentMetadata?.recommender,
  };

  if (!role.url) {
    return null;
  }

  return (
    <Link
      variant="quiet"
      href={role.url}
      css={[typography2.actionSecondary, styles.link]}
      component="a"
      onClick={() =>
        trackV3('click_button', {
          button: {
            linkName: 'lihp_rdp_link',
            name: 'role_info',
            linkURL: role.url,
            pageConfigComponent: pageConfigComponentTrackingData,
          },
          role: { roleSlug: role.slug },
          carousel: carouselTrackingData,
        })
      }
    >
      {_t('View role details')}
    </Link>
  );
};

export default RecommendedRoleSecondaryCta;
